const styles = theme => ({
  wrapper: {
    width: 1140,
    margin: '0 auto 50px auto',
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: '10px',
    padding: '10px',
    [theme.breakpoints.down('md')]: {
      width: 940
    },
    [theme.breakpoints.down('sm')]: {
      width: '90%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '95%'
    }
  },
  thumbnail: {
    height: 90,
    width: 90,
    marginRight: '10px',
    borderRadius: '5px',
    cursor: 'pointer',
    border: '1px solid #fff',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      height: 80
    }
  },
  selected: {
    border: '2px solid #FF0000'
  },
  expansionPanel: {
    backgroundColor: '#252525',
    color: '#fff',
    border: '1px solid #fff'
  },
  expandIcon: {
    color: '#fff',
    fontSize: 22
  },
  cameraFeedsLabel: {
    fontSize: 16
  },
  nameWrapper: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    borderRadius: '5px 5px 0 0',
    '& > p': {
      fontSize: 14
    }
  },
  flagIcon: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    position: 'absolute',
    top: 5,
    right: 5,
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    color: '#FF0000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  openInNewIcon: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    position: 'absolute',
    top: 5,
    right: 5,
    height: '20px',
    width: '20px',
    borderRadius: '50%',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  label: {
    fontSize: 16,
  },
  rootLabel: {
    marginBottom: 0,
    marginLeft: 0
  },
  featuredStream: {
    border: '1px solid #FF0000',
    borderRadius: '10px',
    padding: '5px'
  },
  checkbox: {
    color: '#fff',
    transform: 'scale(1.5)',
    padding: '10px 10px 10px 12px'
  },
  checked: {
    color: '#FF0000 !important'
  },
  sliderWrapper: {
    height: '100%',
    overflowX: 'scroll',
    userSelect: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  slider: {
    display: 'inline-flex',
  },
  arrow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '25px',
    height: 40,
    width: 40,
    borderRadius: '50%',
    backgroundColor: '#fff',
    color: '#000',
    cursor: 'pointer',
    zIndex: 1,
  },
  arrowLeft: {
    left: 0,
    bottom: 0,
  },
  arrowRight: {
    right: 0,
    bottom: 0,
  },
  arrowIcon: {
    fontSize: '30px'
  },
  infoIcon: {
    fontSize: '20px',
    cursor: 'pointer'
  },
  tooltip: {
    fontSize: '16px'
  }
});

export default styles;
